import { render, staticRenderFns } from "./PerfilV.vue?vue&type=template&id=6a810d6c"
import script from "./PerfilV.vue?vue&type=script&lang=js"
export * from "./PerfilV.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports